module.exports = __webpack_public_path__ + "static/media/photo5@2x.5824b50e.jpg";